import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import * as Yup from 'yup';
import { Formik } from 'formik';
import { updatePassword, user, getUser, status } from "../../reducers/users";
import AddressModal from "../modals/AddressModal";
import BalanceModal from "../modals/BalanceModal";
import RoleModal from "../modals/RoleModal";
import UserSubsiteModal from "../modals/UserSubsiteModal";
import { useParams, useLocation } from "react-router-dom";
import { PersonCircle, Person, Sliders, Lock, Diagram2, CashCoin, Envelope, GeoAltFill, BagFill, PersonFill, PersonFillExclamation, Pencil } from 'react-bootstrap-icons';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import UserService from "../../services/user.service";
import NameModal from "../modals/NameModal";
import PhoneModal from "../modals/PhoneModal";
import TitleModal from "../modals/TitleModal";
import UsernameEmailModal from "../modals/UsernameEmailModal";
import MailHistoryModal from "../modals/MailHistoryModal";
import { getSubsite, getUserCapabilities } from '../../reducers/auth';
import CapabilityModal from "../modals/CapabilityModal";
import ReportService from "../../services/report.service";

const UserDetails = () => {
  const { userId } = useParams();
  console.log("USAER ID", userId);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //  const userProfile = useSelector(user);
  const [passwordModalShow, setPasswordModalShow] = useState(false);
  const [addressModalShow, setAddressModalShow] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [currentAddress, setCurrentAddress] = useState(null);
  const [balanceModalShow, setBalanceModalShow] = useState(false);
  const [rolesModalShow, setRolesModalShow] = useState(false);
  const [subsiteModalShow, setSubsiteModalShow] = useState(false);
  const [nameModalShow, setNameModalShow] = useState(false);
  const [phoneModalShow, setPhoneModalShow] = useState(false);
  const [titleModalShow, setTitleModalShow] = useState(false);
  const [usernameEmailModalShow, setUsernameEmailModalShow] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const location = useLocation();
  let userProfile = useSelector(user);
  const { isAdmin, isSuperAdmin, isSupervisor, loading } = useSelector(state => state.auth);
  const userCapabilities = useSelector(getUserCapabilities);
  const canRemoveUser = isAdmin || isSuperAdmin || userCapabilities?.some(c => c.capabilityName === "REMOVE_USER");
  const canUpdateBalance = isAdmin || isSuperAdmin || userCapabilities?.some(c => c.capabilityName === "UPDATE_USER_BALANCE");
  const [balanceRollsOver, setBalanceRollsOver] = useState();
  const [mailHistoryModalShow, setMailHistoryModalShow] = useState(false);
  const [capabilityModalShow, setCapabilityModalShow] = useState(false);
  const [capabilityList, setCapabilityList] = useState([]);
  const [productCapabilityList, setProductCapabilityList] = useState([]);
  const [subsites, setSubsites] = useState([]);
  const [currentOrderPage, setCurrentOrderPage] = useState(1);
  const [ordersPerPage] = useState(10);
  const [downloadingReport, setDownloadingReport] = useState(false);
  const [scheduledBalances, setScheduledBalances] = useState([]);

  const loadingUserStatus = useSelector(status);
  const currentSubsite = useSelector(getSubsite);

  const loadScheduledBalances = async (userId) => {
    try {
      const response = await UserService.getScheduledBalances(userId);
      setScheduledBalances(response);
    } catch (error) {
      console.error("Error loading scheduled balances:", error);
    }
  };

  const loadAddresses = async (userId) => {
    try {
      const response = await UserService.getAddressesForUser(userId);
      setAddresses(response.data.addresses || []);
    } catch (error) {
      console.error("Error loading addresses:", error);
      setAddresses([]);
    }
  };

  const handleDeleteScheduledBalance = async (id) => {
    if (window.confirm("Are you sure you want to delete this scheduled balance?")) {
      try {
        await UserService.deleteScheduledBalance(id);
        loadScheduledBalances(userProfile.id);
      } catch (error) {
        console.error("Error deleting scheduled balance:", error);
      }
    }
  };

  useEffect(() => {
    console.log("STATUS", loadingUserStatus);
    if (!userProfile || !userProfile.id) return;
    if (loadingUserStatus === 'idle') {
      dispatch(getUser(userId));
    } else if (loadingUserStatus === 'succeeded') {
      console.log("USER PROFILE", userProfile);
      if (userProfile.error) {
        navigate("/admin/users");
      }
      setBalanceRollsOver(userProfile.subsite_balances[0]?.balanceRollsOver ? userProfile.subsite_balances[0]?.balanceRollsOver : false);
      setCapabilityList(userProfile?.user_subsites[0]?.capabilities || []);
      setProductCapabilityList(
        userProfile?.user_subsites[0]?.productCapabilities
        || userProfile?.user_subsites[0]?.product_capabilities
        || []
      );
      if (canUpdateBalance) {
        loadScheduledBalances(userProfile.id);
      }
      loadAddresses(userProfile.id);
    }
    const fetchSubsites = async () => {
      console.log("FETCHING SUBSITES");
      const response = await UserService.getUserSubsites(userProfile.id);
      setSubsites(response.data);
      console.log("FETCHING SUBSITES", response.data);
    };
    fetchSubsites();
  }, [userProfile, dispatch]);

  useEffect(() => {
    dispatch(getUser(userId));
  }, [userId, dispatch]);

  const handlePasswordClick = (values, { setSubmitting, resetForm }) => {
    //setSubmitting(true);

    dispatch(updatePassword(values));

    setPasswordModalShow(false);

  }

  const showPasswordModal = () => {
    setPasswordModalShow(true);
  }

  const passwordModalClose = () => {
    setPasswordModalShow(false);
  }

  const closeAddressModal = (updatedAddress) => {
    setAddressModalShow(false);
    setCurrentAddress(null);
    if (updatedAddress && userProfile?.id) {
      loadAddresses(userProfile.id);
    }
  }
  const showAddressModal = (address) => {
    setCurrentAddress(address);
    setAddressModalShow(true);
  }
  const showAddAddressModal = () => {
    setCurrentAddress({
      name: `${userProfile?.firstname || ""} ${userProfile?.lastname || ""}`.trim()
    });
    setAddressModalShow(true);
  }

  const closeBalanceModal = () => {
    setBalanceModalShow(false);
    dispatch(getUser(userId));
    loadScheduledBalances(userProfile.id);
  }
  const showBalanceModal = () => {
    setBalanceModalShow(true);
  }

  const closeRolesModal = () => {
    setRolesModalShow(false);
  }
  const showRolesModal = () => {
    setRolesModalShow(true);
  }
  const closeSubsiteModal = () => {
    setSubsiteModalShow(false);
    dispatch(getUser(userId));

  }
  const showSubsiteModal = () => {
    setSubsiteModalShow(true);
  }
  const closeMailHistoryModal = () => {
    setMailHistoryModalShow(false);
  }
  const showMailHistoryModal = () => {
    setMailHistoryModalShow(true);
  }

  const showCapabilityModal = () => {
    setCapabilityModalShow(true);
  }
  const closeCapabilityModal = (update, lists) => {
    setCapabilityModalShow(false);
    if (update && lists) {
      setCapabilityList(lists.admin || []);
      setProductCapabilityList(lists.product || []);
    }
  }

  const deactivateUser = async () => {
    var status = await UserService.deactivateUser(userProfile.id);
    if (status.error) {
      alert("Error deactivating user:" + status.message);
    } else {
      dispatch(getUser(userId));
    }
  }

  const reactivateUser = async () => {
    var status = await UserService.reactivateUser(userProfile.id);
    if (status.error) {
      alert("Error reactivating user:" + status.message);
    } else {
      dispatch(getUser(userId));
    }
  }
  const createCheck = () => {

    return (
      <p> <input type="checkbox" id="rollover" name="rollover" onChange={(e) => { setBalanceRollsOver(e.target.checked); UserService.updateBalanceRollsOver({ userId: userProfile.id, balanceRollsOver: e.target.checked }); }} checked={balanceRollsOver} /> Balance Rolls Over</p>
    );
  }
  const sendRegistrationEmail = async () => {
    var status = await UserService.sendUnregisteredEmail(userProfile.id);
    if (status.error) {
      setEmailSent(status.error);
    } else {
      setEmailSent("Email Sent");
    }
  }

  const downloadUserReport = async () => {
    setDownloadingReport(true);
    try {
      await ReportService.downloadUserDetailsReport(userId);
    } catch (error) {
      console.error("Error downloading user report:", error);
      alert("Error downloading user report");
    } finally {
      setDownloadingReport(false);
    }
  }

  // Schema for yup
  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string()
      .required("*Password is required"),
    newPassword: Yup.string()
      .min(8, "*Passwords must be 8 characters")
      .max(100, "*Passwords can't be longer than 100 characters")
      .required("*New Password is required"),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
  });

  // Schema for yup
  const addressValidationSchema = Yup.object().shape({
    street: Yup.string()
      .required("*Street is required"),
    city: Yup.string()
      .required("*City is required"),
    state: Yup.string()
      .required("*State is required"),
    zip: Yup.string()
      .required("*Zip Code is required")
      .min(5, "*Zip Code must be at least 5 digits")
      .max(10, "*Zip Code can't be more than 10 digits"),
  });
  if (!userProfile || JSON.stringify(userProfile) === '{}') {
    return (
      <div>Loading...</div>
    );
  } else {
    console.log("USER PROFILE", userProfile, loadingUserStatus);
    return (
      <div className="user-details-container">
        <Container className="user-data">
          <Row>
            <Col className="icon">
              {userProfile.registration_id || !userProfile.active ? <PersonFillExclamation size={60} color={"#990000"} /> : <PersonCircle size={60} color={"#009900"} />}
              <Col className="header">{userProfile?.firstname} {userProfile?.lastname} &nbsp;
                <Pencil size={20} onClick={() => setNameModalShow(true)} />
              </Col>
            </Col>
          </Row>
          {(isAdmin || isSuperAdmin) && (
            <Row>
              <Col>
                <Button
                  variant="primary"
                  onClick={downloadUserReport}
                  disabled={downloadingReport}
                  size="sm"
                >
                  {downloadingReport ? 'Generating Report...' : 'Download User Details Report'}
                </Button>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Sliders size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Status</Col>
            <Col className="value">
              {userProfile.registration_id ?
                <Row>
                  <Col className="icon" style={{ color: "#990000" }}>
                    This user has not yet completed registration.
                  </Col>
                  <Col>
                    <Button onClick={() => sendRegistrationEmail(userProfile.id)}>Resend Registration Email</Button>
                    {emailSent && <div>{emailSent}</div>}
                  </Col>
                </Row>
                :
                <Row>
                  <Col className="icon" style={{ color: "#009900" }}>
                    This user completed registration.
                  </Col>
                </Row>
              }
              {!userProfile?.active ? (
                <Row>
                  <Col className="icon" style={{ color: "#990000" }}>
                    This user is Inactive. Inactive users cannot login, but their orders will remain in the system.<br />
                    {canRemoveUser && <Button onClick={reactivateUser}>Reactivate User</Button>}
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col className="icon">
                    Inactive users cannot login, but their orders will remain in the system.<br />
                    {canRemoveUser && <Button onClick={deactivateUser}>Deactivate User</Button>}
                  </Col>
                </Row>

              )}

            </Col>
          </Row>

          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Person size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Username</Col>
            <Col className="value">{userProfile?.email}<Pencil size={20} onClick={() => setUsernameEmailModalShow(true)} />
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Envelope size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Email Address</Col>
            <Col className="value">{userProfile?.email}<Pencil size={20} onClick={() => setUsernameEmailModalShow(true)} />
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Envelope size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Phone Number</Col>
            <Col className="value">{userProfile?.phone || <em>Not set</em>} <Pencil size={20} onClick={() => setPhoneModalShow(true)} />
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Person size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Title</Col>
            <Col className="value">{userProfile?.title || <em>Not set</em>} <Pencil size={20} onClick={() => setTitleModalShow(true)} />
            </Col>
          </Row>
          {(isAdmin || isSuperAdmin) && userProfile?.nhkGate?.requireNewHireKit && (
            <>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
              <Row>
                <Col className="icon">
                  <BagFill size={40} />
                </Col>
              </Row>
              <Row>
                <Col className="title" xs={3}>New Hire Kit Gate</Col>
                <Col className="value">
                  <div>
                    Status: <strong>{
                      userProfile.user_subsites?.[0]?.nhkExempt ? 'exempt'
                        : userProfile.nhkGate?.status || 'unlocked'
                    }</strong>
                    {userProfile.nhkGate?.deadlineAt && (
                      <> · Deadline: {new Date(userProfile.nhkGate.deadlineAt).toLocaleDateString()}</>
                    )}
                    {userProfile.nhkGate?.status === 'locked' && userProfile.nhkGate?.daysLeft != null && (
                      <> · {userProfile.nhkGate.daysLeft} day(s) left</>
                    )}
                    {userProfile.user_subsites?.[0]?.nhkCompletedAt && (
                      <> · Completed: {new Date(userProfile.user_subsites[0].nhkCompletedAt).toLocaleDateString()}</>
                    )}
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <Form.Check
                      type="switch"
                      id="nhkExempt"
                      label="Exempt from NHK gate"
                      checked={!!userProfile.user_subsites?.[0]?.nhkExempt}
                      onChange={async (e) => {
                        await UserService.updateNhKExempt(userProfile.id, e.target.checked);
                        dispatch(getUser(userId));
                      }}
                    />
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <Button size="sm" variant="outline-secondary" onClick={async () => {
                      if (!window.confirm('Reset this user\'s NHK window? They will be locked to the kit page again.')) return;
                      await UserService.resetNhKWindow(userProfile.id);
                      dispatch(getUser(userId));
                    }}>Reset NHK window</Button>
                  </div>
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <GeoAltFill size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Addresses</Col>
            <Col className="value">
              {addresses.length === 0 ? (
                <em>No addresses</em>
              ) : (
                addresses.map((address) => (
                  <div key={address.id} style={{ marginBottom: '1rem' }}>
                    <strong>{address.name}</strong><br />
                    {address.street}<br />
                    {address.street2 ? <>{address.street2}<br /></> : null}
                    {address.city}, {address.state} {address.zipCode}<br />
                    <Button size="sm" variant="outline-secondary" onClick={() => showAddressModal(address)}>Update Address</Button>
                  </div>
                ))
              )}
              <br />
              <Button size="sm" variant="outline-primary" onClick={showAddAddressModal}>Add Address</Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <Lock size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Password</Col>
            <Col className="value">
              <Button size="sm" variant="outline-secondary" onClick={showPasswordModal}>Reset Password</Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="icon">
              <CashCoin size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Roles</Col>
            <Col className="value">
              <ul>
                {
                  userProfile?.user_subsites[0].role.roleName === "siteadmin" && (
                    <li> Site Admin</li>
                  )
                }
                {
                  userProfile?.user_subsites[0].role.roleName === "user" && (
                    <li> User</li>
                  )
                }
                {
                  userProfile?.user_subsites[0].role.roleName === "super" && (
                    <li> Super Admin</li>
                  )
                }
              </ul>
              {(isAdmin || isSuperAdmin) && (
                <Button size="sm" variant="outline-secondary" onClick={showRolesModal}>Update Roles</Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          {(canUpdateBalance) && (
            <><Row>
              <Col className="icon">
                <CashCoin size={40} />
              </Col>
            </Row>
              <Row>
                <Col className="title" xs={3}>
                  {currentSubsite.paymentOptions && currentSubsite.paymentOptions == "kit" && (<span># Kits</span>)}
                  {currentSubsite.paymentOptions && currentSubsite.paymentOptions == "itemlimit" && (<span>Item Limit</span>)}
                  {currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit") && (<span>Balance</span>)}

                </Col>
                <Col className="value">
                {currentSubsite.paymentOptions && currentSubsite.paymentOptions == "kit" && (
                    <>
                      <p>{userProfile?.subsite_balances[0]?.balance ? userProfile?.subsite_balances[0]?.balance : 0}</p>
                      <p><Button size="sm" variant="outline-secondary" onClick={showBalanceModal}>Update # Kits</Button></p>
                    </>
                  )}
                  {currentSubsite.paymentOptions && currentSubsite.paymentOptions == "itemlimit" && (
                    <>
                      <p>{userProfile?.subsite_balances[0]?.balance ? userProfile?.subsite_balances[0]?.balance : 0}</p>
                      <p><Button size="sm" variant="outline-secondary" onClick={showBalanceModal}>Update Item Limit</Button></p>
                    </>
                  )}
                  {currentSubsite.paymentOptions && (currentSubsite.paymentOptions != "itemlimit" && currentSubsite.paymentOptions != "kit") && (
                    <>
                      <p>${userProfile?.subsite_balances[0]?.balance ? userProfile?.subsite_balances[0]?.balance : 0}</p>
                      <p><Button size="sm" variant="outline-secondary" onClick={showBalanceModal}>Update Balance</Button></p>
                      {createCheck()}
                    </>
                  )}

                  {/* Scheduled Balances */}
                  {scheduledBalances && scheduledBalances.length > 0 && (
                    <div style={{ marginTop: '15px' }}>
                      <strong>Scheduled Balance Updates:</strong>
                      <Table size="sm" striped style={{ marginTop: '10px' }}>
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Activation Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {scheduledBalances.map((sb) => (
                            <tr key={sb.id}>
                              <td>${sb.amount}</td>
                              <td>{new Date(sb.activationDate).toLocaleDateString()}</td>
                              <td>
                                <Button
                                  size="sm"
                                  variant="outline-danger"
                                  onClick={() => handleDeleteScheduledBalance(sb.id)}
                                >
                                  Cancel
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}

                </Col>
              </Row>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
            </>
          )}
          {isSuperAdmin &&
            <>
              <Row>
                <Col className="icon">
                  <Diagram2 size={40} />
                </Col>
              </Row>
              <Row>
                <Col className="title" xs={3}>Subsites</Col>
                <Col className="value">
                  {subsites?.map(subsite => {
                    console.log("SUBSITE PROFILE", subsite);
                    return (
                      <div>{subsite.subsite.subsiteName}</div>
                    );
                  })}<br /><br />
                  <Button size="sm" variant="outline-secondary" onClick={showSubsiteModal}>Update Subsites</Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
              <Row>
                <Col className="icon">
                  <Diagram2 size={40} />
                </Col>
              </Row>
              <Row>
                <Col className="title" xs={3}>Capabilities</Col>
                <Col className="value">
                  <div className="mb-2"><strong>Admin</strong></div>
                  {capabilityList && capabilityList.length > 0
                    ? capabilityList.map(capability => (
                        <div key={"admin-cap-" + capability.id}>{capability.capabilityName}</div>
                      ))
                    : <div className="text-muted">None</div>}
                  <div className="mt-3 mb-2"><strong>Product</strong></div>
                  {productCapabilityList && productCapabilityList.length > 0
                    ? productCapabilityList.map(capability => (
                        <div key={"product-cap-" + capability.id}>
                          {capability.capabilityTitle
                            ? `${capability.capabilityName} (${capability.capabilityTitle})`
                            : capability.capabilityName}
                        </div>
                      ))
                    : <div className="text-muted">None</div>}
                  <br />
                  <Button size="sm" variant="outline-secondary" onClick={showCapabilityModal}>Update Capabilities</Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>

            </>
          }

          <Row>
            <Col className="icon">
              <Envelope size={40} />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={3}>Mail History</Col>
            <Col className="value">
              <Container>
                <p><Button size="sm" variant="outline-secondary" onClick={showMailHistoryModal}>Show Mail History</Button></p>

              </Container>
            </Col>
          </Row>

          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col className="title" xs={12}>
              <h5 style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                <BagFill size={20} style={{ marginRight: '8px' }} />
                Orders ({userProfile?.orders?.length || 0})
              </h5>

              {userProfile?.orders && userProfile.orders.length > 0 ? (
                <>
                  <Table striped bordered hover responsive size="sm">
                    <thead className="table-dark">
                      <tr>
                        <th>Order ID</th>
                        <th>Cost</th>
                        <th>Order Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const formatDate = (dateString) => {
                          if (!dateString) return 'N/A';
                          return new Date(dateString).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          });
                        };

                        // Calculate pagination
                        const indexOfLastOrder = currentOrderPage * ordersPerPage;
                        const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
                        const currentOrders = userProfile.orders.slice(indexOfFirstOrder, indexOfLastOrder);

                        return currentOrders.map(order => {
                          // Determine order status based on various fields
                          const getOrderStatus = (order) => {
                            if (order.purchaseorder?.finalizedAt || order.purchaseorder?.finalized_at) {
                              return { text: 'Finalized', variant: 'success' };
                            } else if (order.purchaseorder) {
                              return { text: 'In Purchase Order', variant: 'warning' };
                            } else if (order.approvedAt || order.approved_at) {
                              return { text: 'Approved', variant: 'info' };
                            } else if (order.status) {
                              // Handle various status values
                              switch (order.status.toLowerCase()) {
                                case 'completed':
                                case 'complete':
                                  return { text: 'Completed', variant: 'success' };
                                case 'approved':
                                  return { text: 'Approved', variant: 'info' };
                                case 'pending':
                                  return { text: 'Pending', variant: 'warning' };
                                case 'cancelled':
                                case 'canceled':
                                  return { text: 'Cancelled', variant: 'danger' };
                                case 'draft':
                                  return { text: 'Draft', variant: 'secondary' };
                                default:
                                  return { text: order.status, variant: 'secondary' };
                              }
                            } else {
                              return { text: 'Pending', variant: 'secondary' };
                            }
                          };

                          const status = getOrderStatus(order);
                          console.log("ORDER", order);
                          return (
                            <tr key={order.id}>
                              <td><strong>#{order.id}</strong></td>
                              <td>${parseFloat(order.balanceUsed || 0).toFixed(2)}</td>
                              <td>{formatDate(order.placed ? order.placed : order.createdAt)}</td>
                              <td>
                                <span className={`badge bg-${status.variant}`}>
                                  {status.text}
                                </span>
                              </td>
                            </tr>
                          );
                        });
                      })()}
                    </tbody>
                  </Table>

                  {/* Pagination */}
                  {userProfile.orders.length > ordersPerPage && (
                    <div className="d-flex justify-content-center mt-3">
                      <Pagination>
                        <Pagination.First
                          onClick={() => setCurrentOrderPage(1)}
                          disabled={currentOrderPage === 1}
                        />
                        <Pagination.Prev
                          onClick={() => setCurrentOrderPage(prev => Math.max(prev - 1, 1))}
                          disabled={currentOrderPage === 1}
                        />

                        {(() => {
                          const totalPages = Math.ceil(userProfile.orders.length / ordersPerPage);
                          const pages = [];
                          const startPage = Math.max(1, currentOrderPage - 2);
                          const endPage = Math.min(totalPages, currentOrderPage + 2);

                          for (let i = startPage; i <= endPage; i++) {
                            pages.push(
                              <Pagination.Item
                                key={i}
                                active={i === currentOrderPage}
                                onClick={() => setCurrentOrderPage(i)}
                              >
                                {i}
                              </Pagination.Item>
                            );
                          }
                          return pages;
                        })()}

                        <Pagination.Next
                          onClick={() => setCurrentOrderPage(prev =>
                            Math.min(prev + 1, Math.ceil(userProfile.orders.length / ordersPerPage))
                          )}
                          disabled={currentOrderPage === Math.ceil(userProfile.orders.length / ordersPerPage)}
                        />
                        <Pagination.Last
                          onClick={() => setCurrentOrderPage(Math.ceil(userProfile.orders.length / ordersPerPage))}
                          disabled={currentOrderPage === Math.ceil(userProfile.orders.length / ordersPerPage)}
                        />
                      </Pagination>
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center text-muted py-4">
                  <BagFill size={40} className="mb-2" />
                  <p>No orders found for this user.</p>
                </div>
              )}
            </Col>
          </Row>

        </Container>
        {
          passwordModalShow &&
          <Modal show={passwordModalShow} onHide={passwordModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Update Password<br /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{ currentPassword: "", newPassword: "", confirmNewPassword: "" }}
                validationSchema={validationSchema}
                onSubmit={handlePasswordClick}
              >
                {/* Callback function containing Formik state and helpers that handle common form actions */}
                {({ values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting }) => (
                  <Form onSubmit={handleSubmit} >
                    <Form.Group className="mb-3" controlId="currentPassword">
                      <Form.Label>Current Password</Form.Label>
                      <Form.Control
                        name="currentPassword"
                        type="password"
                        placeholder="Current Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.currentPassword}
                        className={touched.currentPassword && errors.currentPassword ? "error" : null}
                      />
                      {touched.currentPassword && errors.currentPassword ? (
                        <div className="error-message">{errors.currentPassword}</div>
                      ) : null}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="newPassword">
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        name="newPassword"
                        type="password"
                        placeholder="New Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.newPassword}
                        className={touched.newPassword && errors.newPassword ? "error" : null}
                      />
                      {touched.newPassword && errors.newPassword ? (
                        <div className="error-message">{errors.newPassword}</div>
                      ) : null}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirmNewPassword">
                      <Form.Label>Confirm New Password</Form.Label>
                      <Form.Control
                        name="confirmNewPassword"
                        type="password"
                        placeholder="Confirm New Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.confirmNewPassword}
                        className={touched.confirmNewPassword && errors.confirmNewPassword ? "error" : null}
                      />
                      {touched.confirmNewPassword && errors.confirmNewPassword ? (
                        <div className="error-message">{errors.confirmNewPassword}</div>
                      ) : null}
                    </Form.Group>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={passwordModalClose}>
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={handlePasswordClick} type="submit" disabled={isSubmitting}>
                        Change Password
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>
        }
        {
          addressModalShow && currentAddress &&
          <AddressModal show={addressModalShow} address={currentAddress} userId={userProfile.id} closeAddressModal={closeAddressModal} />
        }
        {
          balanceModalShow &&
          <BalanceModal show={balanceModalShow} closeModal={closeBalanceModal} userId={userProfile?.id} initialBalance={userProfile?.subsite_balances[0]?.balance} />
        }
        {
          rolesModalShow &&
          <RoleModal user={userProfile} show={rolesModalShow} closeModal={closeRolesModal} />
        }
        {
          subsiteModalShow && isSuperAdmin && (
            <UserSubsiteModal user={userProfile} show={subsiteModalShow} closeModal={closeSubsiteModal} />
          )
        }
        {
          nameModalShow && (
            <NameModal user={userProfile} show={nameModalShow} closeNameModal={() => { dispatch(getUser(userId)); setNameModalShow(false); }} />
          )
        }
        {
          phoneModalShow && (
            <PhoneModal user={userProfile} show={phoneModalShow} closePhoneModal={() => { dispatch(getUser(userId)); setPhoneModalShow(false); }} />
          )
        }
        {
          titleModalShow && (
            <TitleModal user={userProfile} show={titleModalShow} closeTitleModal={() => { dispatch(getUser(userId)); setTitleModalShow(false); }} />
          )
        }
        {
          usernameEmailModalShow && (
            <UsernameEmailModal user={userProfile} show={usernameEmailModalShow} closeUsernameEmailModal={() => { dispatch(getUser(userId)); setUsernameEmailModalShow(false); }} />
          )
        }
        {
          mailHistoryModalShow && (
            <MailHistoryModal user={userProfile} show={mailHistoryModalShow} close={closeMailHistoryModal} />
          )
        }
        {
          capabilityModalShow && (
            <CapabilityModal user={userProfile} show={capabilityModalShow} closeModal={closeCapabilityModal} />
          )
        }
      </div >
    );
  }
};
export default UserDetails; 